<template>
  <div class="user-agreement" v-loading="loading">
    <div class="tit">《用户协议》</div>
    <div class="content" v-if="content" v-html="content"></div>
    <div class="empty-wrapper" v-else-if="!loading">暂无内容</div>
  </div>
</template>

<script>
import { queryConfig } from "@/api/config";

export default {
  name: "UserAgreement",
  data() {
    return {
      loading: false,
      content: "",
    };
  },
  created() {
    this.fetchUserAgreement();
  },
  methods: {
    async fetchUserAgreement() {
      this.loading = true;
      try {
        const res = await queryConfig({
          businessKey: "",
          configKeyList: ["user_privacy_agreement"],
        });
        if (res && res.data) {
          const configData = Array.isArray(res.data) ? res.data : [res.data];
          if (configData.length > 0) {
            this.content = configData[0].configValue || configData[0].content || configData[0].value || "";
          }
        }
      } catch (error) {
        console.error("获取用户协议失败：", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.user-agreement {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  min-height: 600px;
}
.tit {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 28px;
  color: #000000;
  padding: 28px 15px 0px 15px;
}
.content {
  margin-top: 26px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  padding: 0px 34px 34px 34px;
  line-height: 1.8;
}
.content ::v-deep p {
  margin-bottom: 10px;
}
.content ::v-deep h1,
.content ::v-deep h2,
.content ::v-deep h3,
.content ::v-deep h4 {
  margin: 16px 0 10px;
  font-weight: bold;
}
.empty-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}
</style>
